module.exports = __webpack_public_path__ + "static/media/img_questionnaire.1c695bab.svg";